import * as React from "react";
import { connect } from "react-redux";
import { bugsnagClient } from "../bugsnag/bugsnagClient";
import { ErrorBoundary } from "../generic/ErrorBoundary";
import { actionModalCloseLast } from "./actionModal";
var _ErrorBoundaryModal = function (_a) {
    var modalType = _a.modalType, closeLastModal = _a.closeLastModal, children = _a.children;
    var beforeSend = function () { return closeLastModal(modalType); };
    return (React.createElement(ErrorBoundary, { beforeSend: beforeSend, client: bugsnagClient.bugsnag, name: "ErrorBoundaryModal.tsx" }, children));
};
var mapState = function (state, ownProps) { return ownProps; };
var mapDispatch = function (dispatch) { return ({
    closeLastModal: function (modalType) { return dispatch(actionModalCloseLast(modalType)); },
}); };
export var ErrorBoundaryModal = connect(mapState, mapDispatch)(_ErrorBoundaryModal);



//////////////////
// WEBPACK FOOTER
// ./src/features/modals/ErrorBoundaryModal.tsx
// module id = 1370
// module chunks = 3